export const ALL_REACTIONS_DIALOG_TITLE = 'all-reactions-dialog.title';
export const ALL_REACTIONS_DIALOG_ALL = 'all-reactions-dialog.all';
